export function reload(history, path, state = null) {
  setTimeout(() => {
    history.replace({
      pathname: `/home/welcome`,
    });
    history.replace({
      pathname: path,
      state,
    });
  }, 500);
}
